import {
  DermatologyIcon,
  DentistryIcon,
  FamilyMedicineIcon,
  GeneralIcon,
  GeneralSurgeryIcon,
  InternalMedicineIcon,
  KMedicineClinicIcon,
  NeurologyIcon,
  NeurosurgeryIcon,
  ObstetricsIcon,
  OphthalmologyIcon,
  OrthopedicSurgeryIcon,
  OtolaryngologyIcon,
  PainMedicineIcon,
  PediatricsIcon,
  PlasticSurgeryIcon,
  RehabilitationMedicineIcon,
  ThoracicSurgeryIcon,
  UrologyIcon,
} from "../ui/atoms"

export const TREATMENT_ICON_MAP = {
  1: PlasticSurgeryIcon,
  2: DermatologyIcon,
  3: ObstetricsIcon,
  4: DentistryIcon,
  5: OrthopedicSurgeryIcon,
  6: OphthalmologyIcon,
  7: UrologyIcon,
  8: OtolaryngologyIcon,
  9: InternalMedicineIcon,
  10: NeurologyIcon,
  11: PediatricsIcon,
  12: FamilyMedicineIcon,
  13: RehabilitationMedicineIcon,
  14: PainMedicineIcon,
  15: GeneralSurgeryIcon,
  16: NeurosurgeryIcon,
  17: ThoracicSurgeryIcon,
  18: KMedicineClinicIcon,
  19: NeurosurgeryIcon,
  99: GeneralIcon,
} as const

